  <div class="tab-pane active" id="m_tab_search_batches" role="tabpanel">
  	<div class="m-portlet__body" [formGroup]="filterForm">
  		<div class="form-group m-form__group row">
  			<div class="col-lg-2">
  				<label>
  					Disability Type
  				</label>
  				<select name="sector" class="form-control m-input" formControlName="disabilitytype">
  					<option value="All" selected>All</option>
  					<option *ngFor="let opt of disabilityTypeList" [ngValue]="opt">{{opt.pwdDesc}}</option>
  				</select>
  			</div>
  			<div class="col-lg-2">
  				<label>
  					Disability Category
  				</label>
  				<select name="subSector" class="form-control m-input" formControlName="disabilitycategory">
  					<option value="All" selected>All</option>
  					<option *ngFor="let opt of DisabilityCategoryData" [ngValue]="opt">{{opt.Category}}
  					</option>
  				</select>
  			</div>
  			<div class="col-lg-2">
  				<label>
  					Expository Status
  				</label>
  				<select name="status" class="form-control m-input" formControlName="status">
  					<option value="All" selected>All</option>
  					<option *ngFor="let opt of expositoryStatus" [ngValue]="opt.statusID">{{opt.statusDesc}}
  					</option>
  				</select>
  			</div>
  			<div class="col-lg-4">
  				<label>
  					Keyword Search
  				</label>
  				<div class="m-input-icon m-input-icon--left">
  					<input type="text" class="form-control m-input" formControlName="keyword"
  						placeholder="Search By Expository Code or Name">
  					<span class="m-input-icon__icon m-input-icon__icon--left">
  						<span>
  							<i class="la la-search"></i>
  						</span>
  					</span>
  				</div>
  			</div>
  			<div class="col-lg-2" style="padding-top: 2% !important">
  				<button class="btn  btn-primary" (click)="searchData()">Apply</button>
  				<a href="javascript:;" class="m-nav__link" (click)="resetFilter()">
  					<span class="m-nav__link-text color-info">
  						Reset
  					</span>
  				</a>
  			</div>
  		</div>
  	</div>
  </div>
